import React, { createContext } from 'react'
import { appReducer, initialAppState } from './reducers/appReducer'
import { panelsReducer, initialPanelsState } from './reducers/panelsReducer'
import combineReducers from 'react-combine-reducers'
import useThunkReducer from '@hooks/useThunkReducer'
import {
    exercisesReducer,
    initialExercisesState,
} from './reducers/exercisesReducer'
import { filtersReducer, initialFiltersState } from './reducers/filtersReducer'
import { searchReducer, initialSearchState } from './reducers/searchReducer'
import { toastsReducer, initialToastsState } from './reducers/toastsReducer'
import { confirmationReducer, initialConfirmationState } from './reducers/confirmationReducer'
import { breadcrumbsReducer, initialBreadcrumbsState } from './reducers/breadcrumbsReducer'
import { editorReducer, initialEditorState } from './reducers/editorReducer'

/**
 *  App context
 */
export const AppContext = createContext()

/**
 * Provider
 */
export const AppProvider = ({ children }) => {
    const [reducer, initialState] = combineReducers({
        app: [appReducer, initialAppState],
        breadcrumbs: [breadcrumbsReducer, initialBreadcrumbsState],
        panels: [panelsReducer, initialPanelsState],
        exercises: [exercisesReducer, initialExercisesState],
        filters: [filtersReducer, initialFiltersState],
        search: [searchReducer, initialSearchState],
        toasts: [toastsReducer, initialToastsState],
        confirmation: [confirmationReducer, initialConfirmationState],
        editor: [editorReducer, initialEditorState],
    })

    const [state, dispatch] = useThunkReducer(reducer, initialState)
    return (
        <AppContext.Provider value={[state, dispatch]}>
            {children}
        </AppContext.Provider>
    )
}
